import cookies from '../../constants/cookies';
import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents';
import { isEmptyObject } from '../../utilities/objects';

import { Base } from './Base';

import Cookies from 'js-cookie';

const selectors = {
  dropdownOption: '.location-popup__dropdown-option'
}

const classes = {
  active: 'active'
}
export class LocationPopup extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.setMarkup();
    this.bindFunctions();
    this.cacheElements();
    this.setEventListeners();

    if (window.mosmosh.location) {
      this.setActiveCountry();
    }
  }

  bindFunctions() {
    this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }

  cacheElements() {
    this.countryOptions = this.refs.dropdownList.querySelectorAll(selectors.dropdownOption);
  }

  setEventListeners() {
    const { dropdown } = this.refs
    dropdown.addEventListener('click', this.handleDropdownClick);
  }

  setMarkup() {
    const { title, explanation, continueButton, changeButton } = this.refs;

    if (title) {
      if (window.mosmosh.location && !isEmptyObject(window.mosmosh.location)) {
        title.innerHTML = this.element.dataset.countryTitle.replace('{{ country }}', window.mosmosh.location.country_name);
      } else {
        title.innerHTML = this.element.dataset.otherCountriesTitle;
      }
    }

    if (explanation) {
      if (window.mosmosh.location && !isEmptyObject(window.mosmosh.location)) {
        explanation.innerHTML = '';
      } else {
        explanation.innerHTML = this.element.dataset.otherCountriesExplanation;
      }
    }

    if (continueButton) {
      continueButton.addEventListener('click', (e) => {
        if (e.target.href.includes(window.location.host)) {
          e.preventDefault();
          this.closeOverlay();

          const selected = this.element.dataset.selectedCountry;
          const geoLocation = window.mosmosh.location.country_code;
          const location = selected ? selected : geoLocation ? geoLocation : 'INT';

          Cookies.set(cookies.SELECTED_LOCATION, location, { expires: 1 });

          dispatchEvent(window, events.LOCATION_SET);
        }
      });
    }

    if (changeButton) {
      changeButton.href = window.location.toString().replace(window.location.origin, changeButton.dataset.href);
    }
  }

  closeOverlay() {
    dispatchEvent(window, events.CLOSE_OVERLAY);
  }

  setActiveCountry(country_code = window.mosmosh.location.country_code || 'INT') {

    const { display, dropdownList, continueButton } = this.refs;
    const activeCountry = dropdownList.querySelector(`[data-country=${country_code}]`);

    const theme = window.mosmosh.theme;
    const {home, homeMen} = window.mosmosh.urls
    const isRoot = location.pathname == "/";

    let country_name;

    //Set URL for continue button
    window.mosmosh.locations.forEach((location) => {
      
      if (location.country_code === country_code) {
        country_name = location.country_name;
        /*
          'view=re' renders blank page for redirect, and is necessary for in-page redirect. I.g. when SKU is available.
          isRoot determines if we are redirecting to index or universe home
        */
        const currentHash = sessionStorage.getItem("dpp-hash");
        continueButton.href = `${location.url}${!isRoot ? theme === 'man' ? homeMen : home : ''}?redirect=${location.country_code}${window.mosmosh.productSKU ?`&sku=${window.mosmosh.productSKU}&view=re` : ''}${currentHash}`;
      }
    });
    
    //Clear active state on all options
    this.countryOptions.forEach((option) => {
      option.classList.remove(classes.active);
    });
    
    //Update display to active location
    display.innerHTML = country_name;
    
    //Hide active location from list
    activeCountry.classList.add(classes.active);
    
    setTimeout(() => {
      sessionStorage.removeItem("dpp-hash");
    }, 1000);
  }

  handleDropdownClick(e) {
    const { dropdown, display } = this.refs;
    const { dataset: { country } } = e.target;

    dropdown.classList.toggle('active');

    if (e.target !== display) {
      this.element.dataset.selectedCountry = country;
      this.setActiveCountry(country);

    }
  }
}